import { useQuery } from "@tanstack/react-query";
import type { CardClusterResponse } from "@breeze/shared";
import { fetchCardCluster } from "../api.js";

export function useCardCluster(
  cardId: number | null
): ReturnType<typeof useQuery<CardClusterResponse>> {
  return useQuery<CardClusterResponse>({
    queryKey: ["cluster", cardId],
    queryFn: () => fetchCardCluster(cardId as number),
    enabled: cardId !== null,
    staleTime: 30_000,
  });
}
